import Theme from "sap/ui/core/Theming";

export class ThemeSelector {
  public static getTheme() {
    return localStorage.getItem("theme");
  }

  public static setTheme(sTheme: string) {
    if (sTheme) {
      Theme.setTheme(sTheme);
      localStorage.setItem("theme", sTheme);
    }
  }

  public static initTheme() {
    const sTheme = this.getTheme();
    if (sTheme) {
      this.setTheme(sTheme);
    }
  }
}
